import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./portfolio.css";
import { projects } from "./data/projects";
import { ProductShowcase } from "./components/ProductShowcase";
import { SystemHero } from "./components/SystemHero";
import { ProductFamily } from "./components/ProductFamily";
import { PortfolioNavigation } from "./components/PortfolioNavigation";
import { ProfessionalSections } from "./components/ProfessionalSections";
import { ResumeDialog } from "./components/ResumeDialog";
import { ContactSection, PortfolioFooter } from "./components/ContactSection";
import "./experience-shell.css";
import "./product-refinements.css";

type Theme = "light" | "dark";
function initialTheme(): Theme {
  try {
    const saved = localStorage.getItem("portfolio-theme");
    if (saved === "light" || saved === "dark") return saved;
  } catch {
    /* The theme remains usable when storage is unavailable. */
  }
  return "dark";
}
export const App = () => {
  const [theme, setTheme] = useState<Theme>(initialTheme);
  const [resumeOpen, setResumeOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    document.documentElement.style.colorScheme = theme;
    try {
      localStorage.setItem("portfolio-theme", theme);
    } catch {
      /* Local persistence is optional. */
    }
  }, [theme]);
  useEffect(() => {
    const legacy: Record<string, string> = {
      "/projects": "work",
      "/about_me": "about",
    };
    const target =
      location.hash.slice(1) ||
      legacy[location.pathname] ||
      (location.pathname.startsWith("/projects/")
        ? location.pathname.split("/")[2]
        : "");
    if (target) {
      const frame = requestAnimationFrame(() =>
        document
          .getElementById(target)
          ?.scrollIntoView({ behavior: "instant" as ScrollBehavior })
      );
      return () => cancelAnimationFrame(frame);
    }
  }, [location.pathname, location.hash]);
  const openResume = () => setResumeOpen(true);
  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <PortfolioNavigation
        theme={theme}
        onTheme={() => setTheme(theme === "dark" ? "light" : "dark")}
        onResume={openResume}
      />
      <main id="main" tabIndex={-1}>
        <SystemHero />
        <ProductFamily />
        <div className="project-chapters wrap">
          {projects.map((project, index) => (
            <ProductShowcase key={project.id} project={project} index={index} />
          ))}
        </div>
        <ProfessionalSections />
        <ContactSection />
      </main>
      <PortfolioFooter />
      <ResumeDialog open={resumeOpen} onClose={() => setResumeOpen(false)} />
    </>
  );
};
